import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { TreeNode } from '../../components';
// Components
import { DemoHome } from './demoHome';
// Menus
import { DemoDataGrid, DemoDrawer, DemoForm, DemoRedux, DemoToast } from './pages';

const DemoStack = createStackNavigator();

export const menus: TreeNode[] = [
  {
    id: 0,
    label: 'Home',
    screen: 'demo-home',
  },
  {
    id: 1,
    screen: 'demo-form',
    label: 'Form',
  },
  {
    id: 2,
    screen: 'demo-toast',
    label: 'Toast',
  },
  {
    id: 3,
    screen: 'demo-drawer',
    label: 'Drawer',
  },
  {
    id: 4,
    screen: 'demo-datagrid',
    label: 'Datagrid',
  },
  {
    id: 5,
    screen: 'demo-redux',
    label: 'Redux Toolkits',
  },
];

// Required
export const DemoWebLinksConfig = {
  'demo-home': 'demo-home',
  'demo-form': 'demo-form',
  'demo-toast': 'demo-toast',
  'demo-drawer': 'demo-drawer',
  'demo-redux': 'demo-redux',
  'demo-datagrid': 'demo-datagrid',
};

export const DemoPortalRoutes = () => (
  <DemoStack.Navigator
    screenOptions={{
      headerShown: false,
    }}
    initialRouteName="demo-home"
  >
    <DemoStack.Screen name="demo-home" component={DemoHome} options={{ title: 'Demo Home' }} />
    <DemoStack.Screen name="demo-form" component={DemoForm} options={{ title: 'Demo - Form' }} />
    <DemoStack.Screen name="demo-toast" component={DemoToast} options={{ title: 'Demo - Toast' }} />
    <DemoStack.Screen name="demo-drawer" component={DemoDrawer} options={{ title: 'Demo - Drawer' }} />
    <DemoStack.Screen name="demo-redux" component={DemoRedux} options={{ title: 'Demo - Redux' }} />
    <DemoStack.Screen name="demo-datagrid" component={DemoDataGrid} options={{ title: 'Demo - DataGrid' }} />
  </DemoStack.Navigator>
);
